import React from 'react';

interface Totals {
  subtotal?: number;
  taxAmount?: number;
  lateFee?: number;
  finalTotal?: number;
}

interface InvoiceSummaryCardProps {
  totals: Totals | undefined;
  taxRate: number;
  nextInvoiceNumber: string | undefined | null;
  explicitInvoiceNumber: string | undefined | null;
  formatCurrency: (value: number) => string;
  documentLabel?: string;
  totalLabel?: string;
  hideLateFee?: boolean;
}

const InvoiceSummaryCard: React.FC<InvoiceSummaryCardProps> = ({
  totals,
  taxRate,
  nextInvoiceNumber,
  explicitInvoiceNumber,
  formatCurrency,
  documentLabel = 'invoice',
  totalLabel = 'Total',
  hideLateFee = false,
}) => {
  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-5 elev-1 dark:bg-neutral-900 dark:border-neutral-800" role="region" aria-label={`${documentLabel} summary`} aria-live="polite">
      <div className="space-y-4">
        <div className="flex justify-between">
          <span className="text-sm text-gray-500">Subtotal:</span>
          <span className="text-sm font-semibold text-gray-900 tabular-nums">{formatCurrency(totals?.subtotal || 0)}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-sm text-gray-500">Tax ({taxRate}%):</span>
          <span className="text-sm font-semibold text-gray-900 tabular-nums">{formatCurrency(totals?.taxAmount || 0)}</span>
        </div>
        {!hideLateFee && !!totals?.lateFee && totals.lateFee > 0 && (
          <div className="flex justify-between text-red-700">
            <span className="text-sm">Late Fee:</span>
            <span className="text-sm font-semibold tabular-nums">{formatCurrency(totals.lateFee)}</span>
          </div>
        )}
        <div className="border-t border-gray-200 dark:border-neutral-800 pt-4">
          <div className="flex justify-between text-lg font-extrabold">
            <span>{totalLabel}:</span>
            <span className="tabular-nums">{formatCurrency(totals?.finalTotal || 0)}</span>
          </div>
        </div>
        <div className="text-xs text-gray-500 dark:text-gray-400">
          Next {documentLabel} number: {explicitInvoiceNumber && explicitInvoiceNumber.trim() !== '' ? explicitInvoiceNumber : (nextInvoiceNumber || 'auto-generated on save')}
        </div>
      </div>
    </div>
  );
};

export default InvoiceSummaryCard;



